import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SvgLeftArrow = ({ className, ...props }) => {
  const svgClasses = classNames('svg', 'svg-left-arrow', className);

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" fill="none" className={svgClasses} {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.7 7H4.5l5.6-5.6L8.7 0l-8 8 8 8 1.4-1.4L4.5 9h12.2V7z"
        fill="#333"
      />
    </svg>
  );
};

SvgLeftArrow.propTypes = {
  className: PropTypes.string,
};

export default SvgLeftArrow;
